import {Helper} from 'app/modules/core'
import clsx from 'clsx'

export const FormCheckBox: React.FC<{
  key?: any
  field: {
    name: string
    value: any
    onChange?: (val: React.ChangeEvent<HTMLInputElement>) => void
  }
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  onCheckedChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
  isInline?: boolean
  disabled?: boolean
}> = (props) => {
  const dfVal: boolean = Helper.stringToBoolean(props.field.value)

  return (
    <>
      <label className={clsx('form-check form-check-solid', {'form-check-inline': props.isInline})}>
        <input
          key={props.key}
          className='form-check-input'
          type='checkbox'
          name={props.field.name}
          value=''
          disabled={props.disabled}
          //defaultValue='true'
          checked={dfVal}
          onChange={(val) => {
            val && props.onCheckedChange?.(val)
            val && props.form.setFieldValue(props.field.name, val.target.checked ? true : false)
          }}
        />
        <span className='form-check-label fw-bold'>{props.label}</span>
      </label>
    </>
  )
}
